"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../util/utils");

var abi = __importStar(require("ethereumjs-abi"));

var MultiInvocationFormatter =
/** @class */
function () {
  function MultiInvocationFormatter() {}

  MultiInvocationFormatter.formatMultiInvocation = function (revert, invocations) {
    var data = revert ? "0x01" : "0x00";

    for (var _i = 0, invocations_1 = invocations; _i < invocations_1.length; _i++) {
      var invocation = invocations_1[_i];
      var dataBuffer = Buffer.from(invocation.data.replace("0x", ""), 'hex');
      var dataLength = dataBuffer.length;
      var operationAbi = [{
        value: invocation.to,
        type: "address"
      }, {
        value: utils_1.Utils.bigNumberToBN(utils_1.Utils.normalizeNumber(invocation.value)),
        type: "uint256"
      }, {
        value: dataLength,
        type: "uint256"
      }, {
        value: dataBuffer,
        type: "bytes"
      }];
      var types = operationAbi.map(function (o) {
        return o.type;
      });
      var values = operationAbi.map(function (o) {
        return o.value;
      });
      data += abi.solidityPack(types, values).toString('hex');
    }

    return data;
  };

  return MultiInvocationFormatter;
}();

exports.MultiInvocationFormatter = MultiInvocationFormatter;